
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vanlife-roadtrips",
      function () {
        return require("private-next-pages/vanlife-roadtrips/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vanlife-roadtrips"])
      });
    }
  